<template>
  <div
    id="autocomplete-model"
    :style="'top:' +  (data.top + 25) + 'px;left:' + data.left + 'px;'"
  >
    <div v-if="isSpinner === true">
      <center>
        <div class="lds-hourglass"></div>
      </center>
    </div>

    <div
      v-else
      style="padding-right: 10px;padding-top: 10px;"
    >
      <ul>
        <li
          class="itemModel"
          @click="setOfficialModel('')"
        >
          None
        </li>
      </ul>

      <label
        v-if="list.length === 0"
        style="padding-left:10px;"
      >
        No match models
        <ul>
          <li
            class="itemModel"
            @click="setOfficialModel(model)"
          >
            Create New Model <i class="fas fa-plus"></i>
          </li>
        </ul>
      </label>

      <ul
        v-for="(model, indexModel) in list"
        :key="indexModel"
      >
        <li
          class="itemModel"
          @click="setOfficialModel(model)"
        >
          {{ model }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
  name: 'autocomplete-model',

  data () {
    return {
      list: [],
      isSpinner: true,

      timeSearch: null
    }
  },

  props: {
    data: {
      type: Object
    },

    model: {
      type: String
    }
  },

  components: {
    VSelect
  },

  watch: {
    model () {
      this.isSpinner = true
      this.didYouMeanModel()
    }
  },

  mounted () {
    this.didYouMeanModel()
  },

  methods: {
    didYouMeanModel () {
      if (this.model.length <= 6) return

      clearTimeout(this.timeSearch)

      this.timeSearch = setTimeout(() => {
        this.isSpinner = false

        this.list = this.$store.state.allOfficialModels && this.$store.state.allOfficialModels !== null
          ? (this.$store.state.allOfficialModels.filter(a => a.model.indexOf(this.model) !== -1)).map(a => a.model).sort()
          : []
      })
    },

    setOfficialModel (model) {
      this.model = model
      if (document.getElementById('modalEditField') !== null) {
        this.$emit('set-model-value', model)
      }

      this.$store.commit('setOfficialModel', {
        model: model,
        fieldId: this.data.fieldId,
        page: this.$store.state.fileCurrentPage
      })

      this.$store.dispatch('addOfficialModel', {model: model})

      let updatePdfField = this.data.fieldId.replace(/]_/g, '].')

      const autofillDetail = {
        autofillId: this.$store.state.autofillId,
        templateId: this.$store.state.templates[this.$store.state.currentTemplateName]['_id'],
        pdfField: updatePdfField,
        model: model,
        value: '',
        fieldType: this.data.type,
        createdAt: new Date(),
        updatedAt: new Date()
      }

      this.$bus.emit('saveAutofillDetail', {
        modelValue: model,
        updatePdfField,
        elId: this.data.fieldId,
        autofillDetail,
        model: true
      })
    }
  }
}
</script>

<style>
  #autocomplete-model {
    position: absolute;
    border: 1px solid black;
    z-index: 9999;
    box-shadow: 2px 1px 2px 1px black;
    background-color: white;
  }

  .itemModel:hover {
    background-color: rgb(230, 230, 230);
    cursor: pointer;
  }

  .lds-hourglass {
    display: inline-block;
    position: relative;
    width: 100px;
    height: 34px;
  }
  .lds-hourglass:after {
    content: " ";
    display: block;
    border-radius: 50%;
    width: 0;
    height: 0;
    margin: 6px;
    box-sizing: border-box;
    border: 12px solid rgb(118, 200, 255);
    border-color: rgb(118, 200, 255) transparent rgb(118, 200, 255);
    animation: lds-hourglass 1.2s infinite;
  }
  @keyframes lds-hourglass {
    0% {
      transform: rotate(0);
      animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
    50% {
      transform: rotate(900deg);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    100% {
      transform: rotate(1800deg);
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/editor/modal-edit/AutocompleteModel.vue